import { isEmailBuilderCompactShellViewport } from "../../emailBuilderViewportLayout";

export const EMAIL_BUILDER_SETTINGS_PANEL_WIDTH = 360;

export function emailBuilderUsesDesktopRightSettingsPanel(
  viewportWidth: number | undefined,
): boolean {
  return !isEmailBuilderCompactShellViewport(viewportWidth);
}
